import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { cartCrossIcon, cartDotedLine, } from '../../../assets/images/newImages';
import { RadioGroup, FormControlLabel, Radio, AppBar } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { tip } from '../../../environment/index.js';
import { Loader } from '../../../components/index.js';

function PayFully(props) {
    const { tip, setTip, restaurant, paymentValue, handlePaymentChange, closeCartModal, paymentMethodsObj, paymentBtn, classes, currentLanguage, totalAmount, restaurantSuccess, loading, etisilatLoading, setCartType, createPaymentOrderLoading } = props;
    const [value, setValue] = React.useState(2);
    const [tips, setTips] = useState([]);
    const [tipPercentage, setTipPercentage] = useState(0);
    const [tipAmount, setTipAmount] = useState(0);
    const [payableAmount, setPayAbleAmount] = React.useState(totalAmount);
    const { t, i18n } = useTranslation();
    // console.log("restaurantSuccess",restaurantSuccess);
    
    // State to track selected payment method and button disabled state
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(""); // to track selected payment title
    const [selectedPaymentGatewayId, setSelectedPaymentGatewayId] = useState(""); // to track selected payment gateway ID
    const [isButtonDisabled, setIsButtonDisabled] = useState(true); //to track button state - disabled until payment method is selected

    const viewportHeight = window.innerHeight; //get the hight of visisble window 
    const modalhight = viewportHeight - 44; //40px minus 44 is used to minus the portion having logo in modal
    const modalHightDivision = modalhight - 100;
    const [activeTab, setActiveTab] = useState(0); // Track the active tab index - first tab active by default

    const handleChanges = (event, newValue) => {
        setValue(newValue);
    };

    const handleTabClick = (index, item) => {
        setTipPercentage(parseInt(item.replace('%', '')));// convert the percentage to a number and set the tip percentage
        setActiveTab(index); // Set  the active tab when clicked
    };

    useEffect(() => {
        // Simulating async fetch
        const tipData = [{ percent: "5%" }, { percent: "10%" }, { percent: "15%" }, { percent: "20%" }
            // , { percent: "5%" },
        // { percent: "6%" }, { percent: "7%" }, { percent: "8%" }, { percent: "9%" }, { percent: "10%" }
        ];
        setTips(tipData);
        // Set the first tip as default (5%)
        if (tipData.length > 0) {
            setTipPercentage(parseInt(tipData[0].percent.replace('%', '')));
        }
    }, []);

    // Initialize payment selection when payment methods are loaded
    useEffect(() => {
        if (paymentMethodsObj && paymentMethodsObj.length > 0 && paymentValue) {
            // Find the payment gateway that matches the current paymentValue
            const selectedGateway = paymentMethodsObj.find(item => item._id === paymentValue);
            
            if (selectedGateway) {
                console.log("🔄 Initializing default payment selection:", selectedGateway.title);
                setSelectedPaymentMethod(selectedGateway.title || '');
                setSelectedPaymentGatewayId(paymentValue);
                setIsButtonDisabled(false); // Enable the button since we have a valid selection
            }
        }
    }, [paymentMethodsObj, paymentValue]);

    useEffect(() => {
        const calculatedTip = (tipPercentage / 100) * totalAmount;
        // console.log("calculatedTip", calculatedTip);
        setTip(calculatedTip)
        setTipAmount(parseFloat(calculatedTip).toFixed(2));
        setPayAbleAmount(parseFloat(totalAmount + calculatedTip).toFixed(2))
    }, [tipPercentage]); // Recalculate if tipPercentage or totalAmount changes

      // Wrapper for handling payment selection
    const handlePaymentSelection = (event) => {
        const selectedValue = event.target.value; // Get the selected gateway ID
        const selectedGateway = paymentMethodsObj.find(item => item._id === selectedValue);
        
        if (selectedGateway) {
            setSelectedPaymentMethod(selectedGateway.title || '');
            setSelectedPaymentGatewayId(selectedValue); // Store the gateway ID
            setIsButtonDisabled(false); // Enable the button
        }
        
        handlePaymentChange(event); // Call the original handler passed in props
    };
    const handleViewBill = () =>{
        setCartType(false);
    }

    return (
        <>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <div className='cart-logo'>
                    <img src={restaurant?.logo} className="cart-logo-image" />
                </div>
            </div>

            <div className='cart-main-div-head'>
                <Scrollbars style={{ height: modalHightDivision }} > {/**className='payment-option-scrollbar' */}
                    <div className={currentLanguage?.left_to_right === 0 ? 'cart-head-cross-pay cart-head-cross-pay-rtl' : 'cart-head-cross-pay'}>
                        <h2 className={currentLanguage?.left_to_right === 0 ? 'table-heading pay table-heading-rtl' : 'table-heading pay'}> {t('table')}: 1</h2>
                        <span className='second-modal-cross-svg-style'>
                            <img onClick={closeCartModal} src={cartCrossIcon} />
                        </span>
                    </div>

                    <div className='btn-rounded-border'>
                        {/* <div className="payment-btn-second-payfully-modal" >
                            <button className={currentLanguage?.left_to_right === 0 ? 'payment-button-btn2-payFully payment-btn2-rtl-payfully' : 'payment-button-btn2-payFully'}>
                                {t('splitBill')}
                            </button>
                            <button className={currentLanguage?.left_to_right === 0 ? 'payment-button-btn1-payFully payment-btn1-rtl-payfully ' : 'payment-button-btn1-payFully'}
                            onClick={handleViewBill}>
                                {t('viewBill')}
                            </button>
                        </div> */}
                    </div>

                    <div className='tip-div'>
                        <h3 className={currentLanguage?.left_to_right === 0 ? 'tip-heading tip-heading-rtl' : 'tip-heading'}>
                            Would You Like To Give The Tip ?
                            {/* {t('YourTipsMatter')} */}
                        </h3>
                    </div>

                    <div className={currentLanguage?.left_to_right === 0 ? 'app-bar-rtl' : ''}>
                        {/* <CounterInput value={tipPercentage} setValue={setTipPercentage}
                        /> */}

                        <AppBar position="static" color='transparent' className={classes.testingTab}>
                            <Tabs
                                value={value} // indicatorColor="primary"
                                // textColor="primary"
                                onChange={handleChanges}
                                aria-label="disabled tabs example"
                                variant="scrollable"  // Make the Tabs scrollable
                                scrollButtons="auto"
                                TabIndicatorProps={{
                                    style: { display: 'none' }
                                }}
                            >
                                {tips.map((item, index) => (
                                    <Tab 
                                    style={{color:' #805236'}}
                                        key={index} 
                                        label={item.percent}
                                        onClick={() => handleTabClick(index, item.percent)}
                                        className={`tip-value ${activeTab === index ? 'pecent-div-span' : 'other-tab-div'}`}
                                    />
                                ))}
                            </Tabs>
                        </AppBar>
                    </div>

                    <div className={currentLanguage.left_to_right === 0 ? 'tip-amt-rtl tip-amt' : 'tip-amt'} >
                        <h4 className={currentLanguage?.left_to_right === 0 ? 'tip-amt-arabic' : ''}>{t('tipAmt')}</h4>
                        <p>
                            {restaurantSuccess?.data?.branches[0].currency}. 
                            <span className="tip-amt-span">
                                {tipAmount}
                            </span>
                        </p>
                    </div>

                    <div className='cart-doted-line-div'>
                        <img className='cart-doted-line-div-img' src={cartDotedLine} />
                    </div>

                    <div className={currentLanguage?.left_to_right === 0 ? 'payable-amount-div-rtl payable-amount-div' : 'payable-amount-div'} >
                        <div style={{ paddingLeft: '25px' }}>
                            <h3 className={currentLanguage?.left_to_right === 0 ? 'paya-head paya-head-rtl' : 'paya-head'}>
                                {t('youRPayingFully')}
                            </h3>
                            <p className={currentLanguage?.left_to_right === 0 ? 'paya-parah-rtl paya-parah' : 'paya-parah'}>
                                {t('tipTaxIncluded')}
                            </p>
                        </div>
                        <div>
                            <span className='paya-price-payfully'>
                                {restaurantSuccess?.data?.branches[0].currency}.
                            </span>
                            <span className='paya-price-amount'>
                                {payableAmount} 
                            </span>
                        </div>
                    </div>

                    <div>
                        <h2 className={currentLanguage?.left_to_right === 0 ? 'payment-method-head payment-method-head-rtl' : 'payment-method-head'} > Select {t('paymentMethods')}</h2>
                        <div className='payment-method-div'>
                        <RadioGroup onChange={handlePaymentSelection} value={paymentValue}>
                                {paymentMethodsObj.map((item, index) => (
                                    <div key={item._id || index} className='payment-type-div'>
                                        <FormControlLabel className='radio-form-main-pay'
                                            control={<Radio className={classes.radioForm} color='primary' />}
                                            value={item._id}  // Set the unique value here
                                            // value={paymentValue[index]}
                                            label={
                                                <span className="flag-inner-div-pay">
                                                    <span className='flg-div-pay'><img src={item.img} /></span>
                                                    <span className={`flag-icon flag-icon-${''}`} style={{ marginRight: 10 }}></span>{item.title}
                                                </span>
                                            }
                                        />
                                    </div>
                                ))}
                            </RadioGroup>
                        </div>
                    </div>

                    <div className={currentLanguage?.left_to_right === 0 ? 'terms-div terms-div-rtl' : 'terms-div'} >
                        {/* <p className={currentLanguage?.left_to_right === 0 ? 'terms-div-rtl' : ''}>
                            {t('tapOnPay')}
                            <span className={`terms-span ${currentLanguage?.left_to_right === 0 ? 'terms-div-rtl' : ''}`} >

                                {t('termsOfUse')}
                            </span>
                        </p> */}
                        <div className='pay-btn-parent'>
                            <button className={currentLanguage?.left_to_right === 0 ? 'pay-btn-with pay-btn-with-rtl ' : 'pay-btn-with'} onClick={paymentBtn} disabled={isButtonDisabled || createPaymentOrderLoading}>
                                {/* Pay with */}
                                <span className='paywith-main-loader'>
                                    <span className='proceed'>
                                        Proceed
                                        {/* {t('payWith')} */}
                                    </span>
                                    <span className='pay-loader'>
                                        {   (etisilatLoading || createPaymentOrderLoading) &&
                                            <Loader />
                                        }
                                </span>
                                </span>
                            </button>
                            {/* <button className={currentLanguage?.left_to_right === 0 ? 'pay-btn-with pay-btn-with-rtl ' : 'pay-btn-with'} onClick={paymentBtn}>
                                {t('payWith')} Apple Pay
                            </button> */}
                        </div>
                    </div>
                </Scrollbars >
            </div >
        </>
    )
}
export default PayFully;